import React from 'react'
import { Container, Form, Button } from 'react-bootstrap'

function ContactSection() {
  return (
      <Container className='contact-section' style={{ marginTop: '3rem', color: "#F5F5F5" }}>
        <h2>Contact Us</h2>
        <Form>
          <Form.Group controlId='formName'>
            <Form.Label>Name</Form.Label>
            <Form.Control type='text' placeholder='Enter your name' />
          </Form.Group>
          <Form.Group controlId='formEmail' style={{ marginTop: '1rem' }}>
            <Form.Label>Email address</Form.Label>
            <Form.Control type='email' placeholder='Enter your email' />
          </Form.Group>
          <Form.Group controlId='formMessage' style={{ marginTop: '1rem' }}>
            <Form.Label>Message</Form.Label>
            <Form.Control as='textarea' rows={3} placeholder='Enter your message' />
          </Form.Group>
          <Button variant='primary' type='submit' style={{ marginTop: '1rem' }}>
            Submit
          </Button>
        </Form>
      </Container>
  )
}

export default ContactSection